import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import { GetMarathonUserRegisteredParams, GetMarathonUserRegisteredResponse } from "api/api/marathonsApi/types";

export const getMarathonUserRegistered = createAsyncThunk<
  GetMarathonUserRegisteredResponse,
  { marathonId: number; params?: GetMarathonUserRegisteredParams }
>(
  "marathons/getMarathonUserRegistered",
  async ({ marathonId, params }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonUserRegistered(marathonId, params || {});
      return data;
    } catch (error: any) {
      console.error("Error while getting user details", error);
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);